module.exports = __webpack_public_path__ + "img/map_location_icon.88b7ebfb.svg";